// Reusable informational popup. The same <AnnouncementDialog/> host (mounted
// once at the app root) powers both the automatic admin-only "what's new" popup
// (server-driven) and ad-hoc info popups opened programmatically via showInfo().

let opener = null;

// Registered by the mounted <AnnouncementDialog /> host.
export function registerAnnouncementDialog(fn) {
  opener = fn;
}

// Open the dialog with arbitrary content. item: { title, body, version? }.
export function showInfo(item) {
  if (opener && item?.title) opener(item);
}
